import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import template from './palettePicker.jsx';
import compose from '../../hoc/compose';
import * as colorUtil from '../../util/color';
import displayNames from '../displayNames';
import PALETTE_PRESETS from './palettePickerPresets';
var PalettePicker = /*#__PURE__*/function (_React$Component) {
  function PalettePicker(props) {
    var _this;
    _classCallCheck(this, PalettePicker);
    _this = _callSuper(this, PalettePicker, [props]);
    _this.getPaletteMainColors = function (palette) {
      return palette.map(function (colorSet) {
        return colorSet[2];
      });
    };

    // TODO: consider something cheaper performance-wise
    _this.isSelectedPalette = function (palette) {
      return _.isEqual(palette, _this.props.value);
    };
    _this.isLightColor = function (color) {
      return _(color).thru(colorUtil.hexToHsb).thru(colorUtil.getDistanceToWhite).value() < 3;
    };
    return _this;
  }
  _inherits(PalettePicker, _React$Component);
  return _createClass(PalettePicker, [{
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);
}(React.Component);
PalettePicker.displayName = displayNames.PALETTE_PICKER;
PalettePicker.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** A list of palettes */
  palettePresets: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))),
  /** Invoked on selecting a palette. Parameters:
   *  <ol>
   *    <li><code>palette</code> - the selected palette <code>{string[][]}</code></li>
   *    <li><code>paletteIndex</code> - the index of the selected palette on <code>palettePresets</code> list <code>{number}</code></li>
   *  </ol>
   */
  onChange: PropTypes.func,
  /** Invoked on mouse entering a palette. Parameters:
   *  <ol>
   *    <li><code>palette</code> - the selected palette <code>{string[][]}</code></li>
   *    <li><code>paletteIndex</code> - the index of the selected palette on <code>palettePresets</code> list <code>{number}</code></li>
   *  </ol>
   */
  onPaletteEnter: PropTypes.func,
  /** Invoked on mouse leaving a palette. Parameters:
   *  <ol>
   *    <li><code>palette</code> - the selected palette <code>{string[][]}</code></li>
   *    <li><code>paletteIndex</code> - the index of the selected palette on <code>palettePresets</code> list <code>{number}</code></li>
   *  </ol>
   */
  onPaletteLeave: PropTypes.func,
  /** Current selected palette */
  value: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
};
PalettePicker.defaultProps = {
  palettePresets: PALETTE_PRESETS,
  onPaletteEnter: _.noop,
  onPaletteLeave: _.noop
};
export default compose(PalettePicker);